<template>
<div>
    <div id="wrapper">
        <ctl-coach-header title="订单详情" left-arrow/>
        <!--banner区域 -->
        <div :class="['statusContent', bgName]">
            <div class="text">
                <div class="status">{{result.orderStatusName}}</div>
                <div v-if="result.orderStatusName === '退款成功' || result.orderStatusName === '退款失败' || result.orderStatusName === '退款中'" class="refundInfo" @click="show = true"><span>退款信息 &nbsp;&nbsp;</span><van-icon name="arrow" /></div>
                <div v-if="result.orderStatusName === '待支付' || result.orderStatusName === '待激活'" class="refundInfo">{{`将于${hour}小时${min}分钟后自动取消`}}</div>
            </div>
        </div>
        <!-- 用户信息 -->
        <div class="userInfo">
            <div class="name">学员姓名：{{result.userName}}</div>
            <div class="phone" @click="call(result.userMobile)">学员电话：{{result.userMobile}}</div>
        </div>
        <!-- 商品信息 -->
        <div class="goodsInfo">
            <h5 class="label">商品信息</h5>

            <van-skeleton title :row="4" :loading="loading">
                <section class="top" >
                        <div class="image"><img class="img" :src="result.goodsPic" /></div>
                        <div class="right-box">
                            <div class="goods-name">{{result.goodsName}}</div>
                            <div class="other-name">{{result.goodsPriceCartModel}}</div>
                            <div class="price">
                                <div>¥{{result.goodsSalePrice}}/{{result.goodsHours}}小时</div>
                                <div>*{{result.goodsPriceNumber}}</div>
                            </div>
                            <div class="remark">{{result.priceRemark}}</div>

                        </div>
                </section>
            </van-skeleton>

            <section class="bottom">
                <van-skeleton title :row="6" :loading="loading">
                <div class="row">
                    <div class="label">配送方式</div>
                    <div class="content">
                      免运费
                    </div>
                </div>
                <div class="row">
                    <div class="label">支付方式</div>
                    <div class="content">
                        {{result.paymentType}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">付款金额</div>
                    <div class="content">
                        <div><span style="color: #FF5050">{{result.paymentType === '激活码' ? '¥0' :  (result.orderAmount >= 0 ? `¥${result.orderAmount}` : '-')}}</span></div>
                    </div>
                </div>
                <div class="row">
                    <div class="label">订单编号</div>
                    <div class="content">
                        {{result.orderNo}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">下单时间</div>
                    <div class="content">
                        {{result.orderTime}}
                    </div>
                </div>
                <div class="row" v-if="result.payTime">
                    <div class="label">支付时间</div>
                    <div class="content">
                        {{result.payTime}}
                    </div>
                </div>
                <div class="row hre" v-if="!((result.orderStatus === '已取消' && !result.coachName ) || (result.orderStatus === '待付款' && !result.coachName ))">
                  <div class="label">陪驾教练</div>
                  <div class="content">
                    {{result.coachName || '——'}}
                  </div>
                </div>
                <div class="row" v-if="!((result.orderStatus === '已取消' && !result.coachMobile ) || (result.orderStatus === '待付款' && !result.coachMobile ))">
                  <div class="label">联系电话</div>
                  <div class="content">
                    <span v-if="result.coachMobile" @click="call(result.coachMobile)">{{result.coachMobile}}</span>
                    <span v-else> —— </span>
                  </div>
                </div>
                </van-skeleton>
            </section>

        </div>
        <div class="footer-pre"></div>
        <!-- 底部按钮区 -->
        <footer class="footer" v-if="result.showRefundBtn || result.showDispatchBtn || result.showFinishBtn">
          <van-button v-if="result.showRefundBtn" class="button" type="default" @click="refund">申请退款</van-button>
          <van-button v-if="result.showDispatchBtn" class="button" type="default"  @click="dispatch">分配订单</van-button>
          <van-button v-if="result.showFinishBtn" class="button" type="default"  @click="finish">完成订单</van-button>
        </footer>
        <!-- 弹窗 -->
        <van-action-sheet class="refund-popup" v-model="show" title="退款信息">
            <div class="dialogwrap">
                <div class="row">
                    <div class="label">申请时间</div>
                    <div class="content">
                        {{result.refundAskTime || '-'}}
                    </div>
                </div>
                <div class="row">
                  <div class="label">退款金额</div>
                  <div class="content">
                    {{result.refundAmount || '-'}}
                  </div>
                </div>
                <div class="row">
                    <div class="label">退款审核</div>
                    <div class="content red">
                        {{result.auditFlag || '-'}}
                    </div>
                </div>
                <div class="row">
                    <div class="label">审核时间</div>
                    <div class="content">
                        {{result.auditTime || '-'}}
                    </div>
                </div>
              <div class="row">
                <div class="label">备注</div>
                <div class="content">
                  {{result.remark || '-'}}
                </div>
              </div>
            </div>
        </van-action-sheet>

        <ctl-dialog v-model="dialogDataRefund" class="refund-dialog">
            <div slot="content" class="content">
                <div class="item">
                    <div class="label">退款方式：</div>
                    <div class="value">全额退款</div>
                </div>
                <div class="item textarea">
                    <div class="label">备注：</div>
                    <div class="value">
                        <van-field
                            v-model="otherReason"
                            rows="4"
                            maxlength="50"
                            type="textarea"
                            placeholder="请输入退款原因"
                        />
                    </div>
                </div>
            </div>
        </ctl-dialog>
        <ctl-dialog v-model="dialogDataDispatch" class="dispatch-dialog">
            <div slot="content" class="content">
                <van-search
                    v-model="keywordCoach"
                    :left-icon="require('@/assets/peijia/icon_search_b.png')"
                    :clearable="false"
                    placeholder="请输入教练姓名、手机号码"
                />
                <div class="card-title">
                    <div class="item">序号</div>
                    <div class="item">教练姓名</div>
                    <div class="item">联系方式</div>
                </div>
                <van-list
                    v-if="coachList.length > 0"
                    v-model="loadingCoach"
                    :error-text="'请求失败， 点击重新加载'"
                    :error.sync="errorCoach"
                    :finished="finishedCoach"
                    @load="getCoachList"
                    finished-text="没有更多了"
                >
                    <div v-for="(v, i) in coachList" :key="i" :class="['card',coachCurrentId === v.id && 'active']" @click="coachCurrentId = v.id">
                        <div class="item">{{i+1}}</div>
                        <div class="item">{{v.coachName}}</div>
                        <div class="item">{{v.phoneNum}}</div>
                    </div>
                </van-list>
            </div>
        </ctl-dialog>
    </div>
</div>
</template>
<script>
import { Skeleton, Button, Icon, ActionSheet, Toast, Dialog, Search, Field, List } from 'vant'
import { setInterval, clearInterval } from 'timers'
import dialog from '@/components/dialog/index'
export default {
    components: {
        [Skeleton.name]: Skeleton,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [List.name]: List,
        [Search.name]: Search,
        [Field.name]: Field,
        ctlDialog: dialog,
        [ActionSheet.name]: ActionSheet
    },
    watch: {
        keywordCoach: {
            handler () {
                this.onSearchCoach()
            },
            deep: true
        }
    },
    data () {
        return {
            otherReason: '',
            // 弹窗数据
            dialogDataRefund: {
                visible: false,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 弹窗数据
            dialogDataDispatch: {
                visible: false,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            timer: null,
            overTime: '', // 截止时间
            hour: '',
            min: '',
            showBandou: false,
            show: false,
            loading: true,
            bgName: 'payment',
            imgUrl: '', // 商品信息里的左侧图片url
            status: '',
            result: {},
            userInfo: {
                name: '',
                phone: '',
                address: ''
            },
            goodsInfo: {
                name: '',
                price: '',
                num: ''
            },
            id: '',
            headHeight: 0,
            detailList: [],
            refundInfo: {},
            loadingCoach: false,
            errorCoach: false,
            finishedCoach: false,
            keywordCoach: '',
            coachList: '',
            serviceProviderId: '',
            coachCurrentId: '',
            pageDataCoach: {
                current: 1,
                size: 10
            }
        }
    },
    methods: {
        // 拨打客服电话
        call (v) {
            this.$jsBridge.callBackHandler('callPhone', { tel: v })
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        // 分配订单
        dispatch () {
            this.serviceProviderId = this.result.providerId
            this.coachCurrentId = ''
            this.getCoachList(1)
            this.dialogDataDispatch.visible = true
            this.dialogDataDispatch.leftBtnMethod = () => {
                this.dialogDataDispatch.visible = false
            }
            this.dialogDataDispatch.rightBtnMethod = () => {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.dispatchProvider({
                    coachId: this.coachCurrentId,
                    ids: [this.id],
                    terminalType: 2
                }).then(res => {
                    if (res.status) {
                        this.getData()
                        this.dialogDataDispatch.visible = false
                        Toast('订单分配成功！')
                    } else {
                        Toast(res.message)
                    }
                })
            }
        },
        // 退款
        refund () {
            this.otherReason = ''
            this.dialogDataRefund.leftBtnMethod = () => {
                this.dialogDataRefund.visible = false
            }
            this.dialogDataRefund.rightBtnMethod = () => {
                this.$api.refundProvider({
                    isAll: true,
                    orderId: this.id,
                    otherReason: this.otherReason
                }).then(res => {
                    Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                    if (res.status) {
                        Toast.clear()
                        this.getData()
                        this.dialogDataRefund.visible = false
                        Dialog.confirm({
                            title: '提示',
                            message: '您的退款申请已提交，请等待斑斑客服处理！',
                            confirmButtonText: '我知道了',
                            showCancelButton: false
                        })
                    } else {
                        Toast(res.message)
                    }
                })
            }
            this.dialogDataRefund.title = '申请退款'
            this.dialogDataRefund.visible = true
        },
        // 搜索教练
        onSearchCoach () {
            this.getCoachList(1)
        },
        // 获取教练数据
        getCoachList (refresh) {
            if (refresh) {
                this.pageDataCoach.current = 1
            }
            const postData = Object.assign({ query: this.keywordCoach, serviceProviderId: this.serviceProviderId }, this.pageDataCoach)
            this.$api.dispatchCoachList(postData).then(res => {
                this.errorCoach = false
                if (res.status) {
                    if (refresh) {
                        this.coachList = res.result.records
                    } else {
                        this.coachList.push(...res.result.records)
                    }
                    this.pageDataCoach.current++
                    this.finishedCoach = res.result.records.length < this.pageDataCoach.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.errorCoach = true
                }
                this.loadingCoach = false
            })
        },
        // 完成订单
        finish () {
            Dialog.confirm({
                title: '提示',
                message: '该学员陪驾服务是否已全部完成？'
            }).then(() => {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.finishProvider({
                    ids: [this.id],
                    terminalType: 2
                }).then(res => {
                    Toast.clear()
                    if (res.status) {
                        this.getData()
                    } else {
                        Toast(res.message)
                    }
                })
            })
        },
        getData () {
            this.$api.getCoachDetails({ orderId: this.id }).then(res => {
                if (res.status) {
                    res.result.orderTime = res.result.orderTime ? this.moment.formatTime(res.result.orderTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.payTime = res.result.payTime ? this.moment.formatTime(res.result.payTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.cancelTime = res.result.cancelTime ? this.moment.formatTime(res.result.cancelTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.auditTime = res.result.auditTime ? this.moment.formatTime(res.result.auditTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.refundAskTime = res.result.refundAskTime ? this.moment.formatTime(res.result.refundAskTime, 'YYYY-MM-DD HH:mm:ss') : ''

                    this.result = res.result
                }
                this.loading = false
            })
        }
    },
    created () {
        this.id = this.$route.query.id
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
  *{
    word-break: break-all;
  }

  .van-search{
      width: 345px;
      margin: 0 auto;
      background: #FFFFFF;
      border-radius: 20px;
      /deep/ {
          .van-search__content{
              background: #ffffff;
              .van-cell{
                  padding: 0;
              }
              .van-cell__value{
                  margin: 0 0 0 8px;
              }
          }
      }
  }
  .dispatch-dialog{
      .van-list{
          padding: 0;
          height: 300px;
          overflow: auto;
      }
      .van-search{
          width: 270px;
          border-radius: 20px;
          border: 1px solid #E6E6E6;
          /deep/ {
              .van-search__content{

              }
              .van-cell{
                  line-height: 1;
              }
          }
      }
      .card-title{
          width: 270px;
          margin: 10px auto 0;
          .item{
              display: inline-block;
              text-align: center;
              font-size: 15px;
              font-weight: 600;
              color: #333333;
          }
          .item:nth-child(1){
              width: 55px;
          }
          .item:nth-child(2){
              width: 80px;
          }
          .item:nth-child(3){
              width: 130px;
          }
      }
      .van-list{
          margin: 17px 0 0 0;
          .card{
              padding: 8px 0;
              width: 270px;
              display: flex;
              justify-content: space-around;
              margin: 0 auto 7px;
              border: 1px solid #ffffff;
          }
          .item{
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: inline-block;
              text-align: center;
              font-size: 15px;
              color: #333333;
          }
          .item:nth-child(1){
              width: 55px;
          }
          .item:nth-child(2){
              width: 80px;
          }
          .item:nth-child(3){
              width: 130px;
          }
          .active{
              position: relative;
              background: #F5FFFB;
              border-radius: 5px;
              border: 1px solid #00CA84;
              &::after{
                  position: absolute;
                  bottom: -1px;
                  right: -1px;
                  content: ' ';
                  width: 16px;
                  height: 14px;
                  background: url("~@/assets/peijia/icon_jlgx.png") no-repeat 100%/100%;
              }
          }
      }
  }
  .refund-dialog{
      .content{
          margin: 15px 0 0 0;
      }
      .item{
          display: flex;
          align-items: center;
          padding: 0 15px;
          .label{
              font-size: 15px;
              font-weight: 600;
              color: #333333;
          }
          .value{
              font-size: 15px;
              font-weight: 400;
              color: #333333;
          }
      }
      .textarea{
          margin: 13px 0 0 0;
          flex-direction: column;
          align-items: flex-start;
          /deep/ {
              .van-cell{
                  padding: 5px 10px;
              }
          }
          .value{
              overflow: hidden;
              margin: 10px 0 0 0;
              width: 100%;
              height: 100px;
              border-radius: 5px;
              border: 1px solid #E6E6E6;
          }
      }
  }
    .footer-pre{
      height: 50px;
    }

    #wrapper{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: absolute;
        background: #fafafa;
    }
    .payment{ // 待付款
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }
    .beshipped{ // 待发货
        background: url('~@/assets/order/bg_to_be_shipped.png') no-repeat center;
    }
    .shipped{ // 已发货
        background: url('~@/assets/order/bg_shipped.png') no-repeat center;
    }
    .completed{ // 已完成
        background: url('~@/assets/order/bg_completed.png') no-repeat center;
    }
    .refund{ // 退款中
        background: url('~@/assets/order/bg_refund.png') no-repeat center;
    }
    .cancelled{ // 已取消
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }
    .shippedInfo{
        margin-top: 7px;
        font: 400 14px PingFangSC-Regular;
        color: rgba(51,51,51,1);
        div{
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .statusContent{
        height: 100px;
        background-size: 100%;
        position: relative;
        .text{
            position: absolute;
            top: 26px;
            left: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 45px;
        }
        .status{
            font: 600 24px PingFangSC-Semibold;
            color: rgba(51,51,51,1);
        }
        .refundInfo{
            display: flex;
            align-items: center;
            padding-top: 10px;
            font: 400 14px PingFangSC-Regular;
            color: rgba(51,51,51,1);
        }
    }
    .userInfo{
        background: white;
        margin-bottom: 10px;
        padding: 15px;
        font: 400 14px PingFangSC-Regular;
        color:rgba(102,102,102,1);
    }
    .goodsInfo{
        background: white;
        padding: 20px 15px 0;
        .label{
            font: 400 14px PingFangSC-Regular;
            color:rgba(102,102,102,1);
        }
        .top{
            display: flex;
            padding: 10px 0 6px;
            align-items: center;
            .image{
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                line-height: 1;
                font-size: 0;
                img{
                    width: 100%;
                }
            }
            .right-box{
                margin-left: 15px;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;
                .goods-name{
                    font: 600 15px PingFangSC-Regular;
                    color:#333333;
                    word-wrap: break-word;
                }
                .other-name{
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: fit-content;
                  margin: 10px 0 0 0;
                  padding: 0 5px;
                  box-sizing: border-box;
                  height: 20px;
                  border-radius: 3px;
                  border: 1px solid #666666;
                  font: 400 14px PingFangSC-Regular, PingFang SC;
                  color: #666666;
                }
                .price{
                    line-height: 1;
                    display: flex;
                    justify-content: space-between;
                    padding-top: 8px;
                    font-size: 14px;
                    color: #666666;
                }
                .remark{
                    margin: 8px 0 0 0;
                    font-size: 12px;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }
        // .bottom{
        // }
    }
    .footer{
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: white;
        box-sizing: border-box;
        padding:  14px 15px;
        .button{
            width: 90px;
            height: 24px;
            margin: 2px;
            line-height: 24px;
            font-size: 14px;
            border-radius: 3px;
            border:1px solid rgba(204,204,204,1);
        }
    }
    .dialogwrap{
        padding: 15px;
    }
    .refund-popup{
      /deep/ .van-action-sheet__header{
        font: 600 18px/64px PingFangSC-Semibold, PingFang SC;
        color: #333333;
      }
    }
    .row{
        &.hre{
          border-top: 1px solid #EEEEEE;
        }
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .label{
            min-width: 100px;
            font: 400 14px PingFangSC-Regular;
            color:rgba(102,102,102,1);
        }
        .content{
            &.red{
              color: #FF5050;
            }
            word-break: break-word;
            font: 400 14px PingFangSC-Regular;
            color:rgba(51,51,51,1);
        }
    }

</style>
